import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'app-slide-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slide-button.html',
  styleUrls: ['./slide-button.scss']
})
export class SlideButton implements AfterViewInit {
  @Input() slideText: string = 'Slide to Confirm';
  @Output() slideComplete = new EventEmitter<void>();

  thumbPosition: number = 0;
  isDragging: boolean = false;
  sliderWidth: number = 0;
  slideConfirmed: boolean = false;

  ngAfterViewInit() {
    const container = document.querySelector('.slider-container') as HTMLElement;
    if (container) {
      this.sliderWidth = container.offsetWidth - 50; // adjust for thumb
    }
  }

  startDrag(event: MouseEvent) {
    this.isDragging = true;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging || this.slideConfirmed) return;

    const container = (event.target as HTMLElement).closest('.slider-container') as HTMLElement;
    if (container) {
      const rect = container.getBoundingClientRect();
      let newLeft = event.clientX - rect.left - 25;
      newLeft = Math.max(0, Math.min(newLeft, this.sliderWidth));
      this.thumbPosition = newLeft;

      if (newLeft >= this.sliderWidth) {
        this.slideConfirmed = true;
        this.isDragging = false;
        this.slideComplete.emit();
      }
    }
  }

  endDrag() {
    if (!this.slideConfirmed) {
      this.thumbPosition = 0;
    }
    this.isDragging = false;
  }

  startTouch(event: TouchEvent) {
    this.isDragging = true;
  }

  onTouchMove(event: TouchEvent) {
    if (!this.isDragging || this.slideConfirmed) return;

    const touch = event.touches[0];
    const container = (event.target as HTMLElement).closest('.slider-container') as HTMLElement;
    if (container) {
      const rect = container.getBoundingClientRect();
      let newLeft = touch.clientX - rect.left - 25;
      newLeft = Math.max(0, Math.min(newLeft, this.sliderWidth));
      this.thumbPosition = newLeft;

      if (newLeft >= this.sliderWidth) {
        this.slideConfirmed = true;
        this.isDragging = false;
        this.slideComplete.emit();
      }
    }
  }
}
